import angular from "angular";
import get from "lodash/get";
import set from "lodash/set";

angular
    .module('ui-sentinel.session')
    .factory('UtilityService', UtilityService);

UtilityService.$inject = ['$rootScope', 'localStorageService'];

function UtilityService($rootScope, localStorageService) {

    const service = {
        loadingCounter: 0,
        getSetting,
        saveSetting,
        loadingIncrement,
        loadingDecrement
    }

    return service;

    function getSetting(key) {
        const rootScopeSetting = get($rootScope, key);
        if (rootScopeSetting) {
            return rootScopeSetting;
        }
        const localStorageSetting = localStorageService.get(key);
        if (localStorageSetting) {
            return restoreValue(localStorageSetting);
        }
        return undefined;
    }

    function saveSetting(key, value) {
        set($rootScope, key, value);
        localStorageService.set(key, storageValue(value));
    }

    function loadingIncrement() {
        service.loadingCounter++;
        if (service.loadingCounter >= 1) {
            $rootScope.loading = true;
            $rootScope.$applyAsync();
        }
    }

    function loadingDecrement() {
        if (service.loadingCounter > 0) {
            service.loadingCounter--;
        }
        if (service.loadingCounter <= 0) {
            $rootScope.loading = false;
            $rootScope.$applyAsync();
        }
    }

    function storageValue(value) {
        if (typeof value === 'object') {
            if (value instanceof Date) {
                return JSON.stringify({
                    name: 'date',
                    value: value.toISOString()
                });
            }
            return JSON.stringify({
                name: 'object',
                value: JSON.stringify(value)
            });
        }
        return JSON.stringify({
            name: 'other',
            value
        });
    }

    function isValidJSON(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return false;
        }
    }

    function restoreValue(value) {
        const json = isValidJSON(value)
        if (!json) {
            return value;
        }
        if (json.name === 'date') {
            return new Date(json.value);
        }
        if (json.name === 'object') {
            return JSON.parse(json.value);
        }
        return json.value;
    }
}
